import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "submit-values" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value"]

import { computed } from 'vue';
import { useStore } from 'vuex';
import type { Address } from '@src/view_models/Address';
import { addressTypeName } from '@src/view_models/AddressTypeModel';
import type { BankAccountValues } from '@src/view_models/BankAccount';
import type { TrackingData } from '@src/view_models/TrackingData';
import type { CampaignValues } from '@src/view_models/CampaignValues';
import type { MembershipFeeValues } from '@src/view_models/MembershipFee';
import { membershipTypeName } from '@src/view_models/MembershipTypeModel';

interface Props {
	trackingData: TrackingData;
	campaignValues: CampaignValues;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SubmitValues',
  props: {
    trackingData: {},
    campaignValues: {}
  },
  setup(__props: any) {



const store = useStore();

const fee = computed( () => store.state.membership_fee.values as MembershipFeeValues );
const address = computed( () => store.state.membership_address.values as Address );
const addressType = computed( () => addressTypeName( store.state.membership_address.addressType ) );
const membershipType = computed( () => membershipTypeName( store.state.membership_address.membershipType ) );
const receipt = computed( () => store.state.membership_address.receipt ? '1' : '0' );
const incentives = computed( () => store.state.membership_address.incentives );
const formattedDateOfBirth = computed( () => ( store.state.membership_address.values.date ?? '' ).replaceAll( '/', '.' ) );
const bankdata = computed( () => store.state.bankdata.values as BankAccountValues );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("input", {
      type: "hidden",
      name: "membership_type",
      value: membershipType.value
    }, null, 8, _hoisted_2),
    _createElementVNode("input", {
      type: "hidden",
      name: "payment_type",
      value: fee.value.type
    }, null, 8, _hoisted_3),
    _createElementVNode("input", {
      type: "hidden",
      name: "membership_fee_interval",
      value: fee.value.interval
    }, null, 8, _hoisted_4),
    _createElementVNode("input", {
      type: "hidden",
      name: "membership_fee",
      value: fee.value.fee
    }, null, 8, _hoisted_5),
    _createElementVNode("input", {
      type: "hidden",
      name: "iban",
      value: bankdata.value.iban
    }, null, 8, _hoisted_6),
    _createElementVNode("input", {
      type: "hidden",
      name: "bic",
      value: bankdata.value.bic
    }, null, 8, _hoisted_7),
    _createElementVNode("input", {
      type: "hidden",
      name: "adresstyp",
      value: addressType.value
    }, null, 8, _hoisted_8),
    _createElementVNode("input", {
      type: "hidden",
      name: "anrede",
      value: address.value.salutation
    }, null, 8, _hoisted_9),
    _createElementVNode("input", {
      type: "hidden",
      name: "titel",
      value: address.value.title
    }, null, 8, _hoisted_10),
    _createElementVNode("input", {
      type: "hidden",
      name: "vorname",
      value: address.value.firstName
    }, null, 8, _hoisted_11),
    _createElementVNode("input", {
      type: "hidden",
      name: "nachname",
      value: address.value.lastName
    }, null, 8, _hoisted_12),
    _createElementVNode("input", {
      type: "hidden",
      name: "firma",
      value: address.value.companyName
    }, null, 8, _hoisted_13),
    _createElementVNode("input", {
      type: "hidden",
      name: "strasse",
      value: address.value.street
    }, null, 8, _hoisted_14),
    _createElementVNode("input", {
      type: "hidden",
      name: "postcode",
      value: address.value.postcode
    }, null, 8, _hoisted_15),
    _createElementVNode("input", {
      type: "hidden",
      name: "ort",
      value: address.value.city
    }, null, 8, _hoisted_16),
    _createElementVNode("input", {
      type: "hidden",
      name: "country",
      value: address.value.country
    }, null, 8, _hoisted_17),
    _createElementVNode("input", {
      type: "hidden",
      name: "email",
      value: address.value.email
    }, null, 8, _hoisted_18),
    _createElementVNode("input", {
      type: "hidden",
      name: "donationReceipt",
      value: receipt.value
    }, null, 8, _hoisted_19),
    _createElementVNode("input", {
      type: "hidden",
      name: "dob",
      value: formattedDateOfBirth.value
    }, null, 8, _hoisted_20),
    _createElementVNode("input", {
      type: "hidden",
      name: "incentives[]",
      value: incentives.value
    }, null, 8, _hoisted_21),
    _createElementVNode("input", {
      type: "hidden",
      name: "impCount",
      value: __props.trackingData.impressionCount
    }, null, 8, _hoisted_22),
    _createElementVNode("input", {
      type: "hidden",
      name: "bImpCount",
      value: __props.trackingData.bannerImpressionCount
    }, null, 8, _hoisted_23),
    _createElementVNode("input", {
      type: "hidden",
      name: "piwik_campaign",
      value: __props.campaignValues.campaign
    }, null, 8, _hoisted_24),
    _createElementVNode("input", {
      type: "hidden",
      name: "piwik_kwd",
      value: __props.campaignValues.keyword
    }, null, 8, _hoisted_25)
  ]))
}
}

})